// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Tooltip_Tooltip__dYSRy","Pointer":"Tooltip_Pointer__1eqlW","Content":"Tooltip_Content__b2RnQ"};